/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {
  // ndc_activity: [],
  // activity_type_principal: false,
  // activity_type_interest: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.ACC_REC_NDC_ACTIVITY_HEAD:
      return { ...state, ndc_activity_head: action.payload };
    case actiontypes.ACC_REC_NDC_RESPONSE:
      return { ...state, ndc_activity_response: action.payload };
    case actiontypes.ACC_REC_NDC_ACTIVITY:
      return { ...state, ndc_activity: action.payload };
    case actiontypes.ACTIVITY_TYPE_PRINCIPAL:
      return { ...state, activity_type_principal: action.payload };
    case actiontypes.ACTIVITY_TYPE_INTEREST:
      return { ...state, activity_type_interest: action.payload };
    case actiontypes.NDC_ACTIVITY_FIRST_LOAD:
      return { ...state, ndcActFirstLoad: action.payload };
    case actiontypes.ACCOUNT_REC_NDC_ACTIVITY_CLEAR_REDUX:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
